export default function ExtractedInferredIco() {
  return (
    <svg
      width="6"
      height="14"
      viewBox="0 0 6 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="3" cy="11" r="3" fill="#0070F2" />
      <circle cx="3" cy="3" r="3" fill="#475E75" />
    </svg>
  );
}
